/**
 * Row data: feature flags. Every flag defaults to off. `since` is the gate of the SMOKE version
 * that first checks the flag (test strategy section 2). `design` also carries `devDefault`, the
 * value development and test builds use when no `flags` setting exists (P0-9 relies on it).
 * `page_split`, `reference` and `statblock_form` are 1.0b's (deliverable 15); SMOKE v1b's SRD
 * check keys on `reference`. Pure data (excluded from mutation testing).
 */
export const FLAG_ROWS = [
    {
        key: 'shell',
        default: false,
        since: 'exit-1a',
        owner: 'P0-3',
        description: 'The Phase 1 shell: sidebar, tabs, palette and right rail.',
    },
    {
        key: 'chrono',
        default: false,
        since: 'exit-1b',
        owner: 'P0-3',
        description: 'Chronology: calendar, When input and Chronicle.',
    },
    {
        key: 'ledger',
        default: false,
        since: 'exit-1b',
        owner: 'P0-3',
        description: 'Secrets page, play and discovery logs, and minimal session creation.',
    },
    {
        key: 'catalogue',
        default: false,
        since: 'exit-1b',
        owner: 'P0-3',
        description: 'Catalogue tables and the Inbox.',
    },
    {
        key: 'import',
        default: false,
        since: 'exit-2a',
        owner: 'P0-3',
        description: 'Notion workspace import.',
    },
    {
        key: 'sessions',
        default: false,
        // Re-dated by CS r4a (2a plan §2): Tonight and Run mode are Phase 2b's.
        since: 'exit-2b',
        owner: 'P0-3',
        description: 'Tonight, run sheet and Run mode.',
    },
    {
        key: 'sheets',
        default: false,
        // Re-dated by CS r4a (2a plan §2): character sheets and the actor import are Phase 2c's.
        since: 'exit-2c',
        owner: 'P0-3',
        description: 'Character sheets and Foundry actor import.',
    },
    {
        key: 'ai',
        default: false,
        since: 'exit-3a',
        owner: 'P0-3',
        description: 'AI features: Canon Chat, selection actions and Review.',
    },
    {
        key: 'views',
        default: false,
        since: 'exit-4',
        owner: 'P0-3',
        description: 'Board, gallery and timeline views.',
    },
    {
        key: 'foundry-export',
        default: false,
        since: 'exit-5',
        owner: 'P0-3',
        description: 'Export to Foundry VTT.',
    },
    {
        key: 'reference_picker',
        default: false,
        // DECISIONS 532: 1.F-s, which this flag gates, ships right after exit 1b.
        since: 'exit-2a',
        owner: 'P0-3',
        description: 'The SRD group in the @ picker and the /statblock, /spell and /item commands.',
    },
    {
        key: 'page_split',
        default: false,
        since: 'exit-1a',
        owner: '1.0b',
        description: 'Turn into page, Move to and Split at heading.',
    },
    {
        key: 'reference',
        default: false,
        since: 'exit-1b',
        owner: '1.0b',
        description: 'The SRD shelf, reference pages and embeds.',
    },
    {
        key: 'statblock_form',
        default: false,
        since: 'exit-1b',
        owner: '1.0b',
        description: 'The homebrew stat-block form.',
    },
    {
        key: 'design',
        default: false,
        devDefault: true,
        since: 'design',
        owner: 'P0-3',
        description: 'The /design gate page with the three visual directions.',
    },
];
//# sourceMappingURL=rows-flags.js.map